import { useEffect, useState } from 'react';
import { debounce } from './debounce';

export function useCheckTextWrap(ref: React.RefObject<HTMLHeadingElement>) {
  const [isWrapped, setIsWrapped] = useState(false);
  useEffect(() => {
    const checkWrap = () => {
      if (ref.current) {
        const lineHeight = parseInt(
          window.getComputedStyle(ref.current).lineHeight,
          10,
        );
        const actualHeight = ref.current.offsetHeight;
        if (actualHeight > lineHeight) {
          setIsWrapped(true);
        } else {
          setIsWrapped(false);
        }
      }
    };
    const debouncedCheckWrap = debounce(checkWrap, 300);
    window.addEventListener('resize', debouncedCheckWrap);
    checkWrap();
    return () => window.removeEventListener('resize', debouncedCheckWrap);
  }, [ref]);
  return isWrapped;
}
